import Image from 'next/image';
import type { FC } from 'react';
import { useEffect, useRef } from 'react';

import { emptyPlaceholder } from '~constants/images';
import { mediaApi } from '~services/api/media';
import { Loader } from '~shared/ui/atoms';

import { enrichUrlWithLoadingMarker } from './loader';
import type { TChatImageProps } from './types';

export const FallbackPrivateChatImage: FC<TChatImageProps> = ({
	width,
	height,
	fallbackUrl,
	quality,
	onClick,
}) => {
	const imageRef = useRef<HTMLImageElement>(null);
	const newUrl = enrichUrlWithLoadingMarker(fallbackUrl);
	const { data, isSuccess } = mediaApi.useGetImageSrcQuery({ url: newUrl });
	useEffect(() => {
		if (isSuccess) {
			imageRef?.current?.classList?.remove?.('loading');
		}
	}, [isSuccess]);
	return (
		<>
			<Image
				onClick={onClick}
				src={data ? data : emptyPlaceholder}
				ref={imageRef}
				alt=""
				quality={quality}
				width={width}
				height={height}
				className="botImage loading"
			/>
			<Loader />
		</>
	);
};
